import { useState } from "react";

import {
  MdClose,
  MdRemove,
  MdAdd,
  MdRestaurant,
} from "react-icons/md";

import "./AddMenuModal.css";

function AddMenuModal({
  onClose,
  onSave,
  saving = false,
}) {

  // =========================================================
  // STATE
  // =========================================================

  const [foodName, setFoodName] =
    useState("");

  const [description, setDescription] =
    useState("");

  const [price, setPrice] =
    useState(10);


  // =========================================================
  // PRICE - DECREASE
  // =========================================================

  const decreasePrice = () => {

    setPrice(
      previous =>
        Math.max(
          1,
          previous - 5
        )
    );

  };


  // =========================================================
  // PRICE - INCREASE
  // =========================================================

  const increasePrice = () => {

    setPrice(
      previous =>
        previous + 5
    );

  };


  // =========================================================
  // SAVE
  // =========================================================

  const handleSave =
    async (event) => {

      event.preventDefault();


      const trimmedName =
        foodName.trim();

      const trimmedDescription =
        description.trim();


      // -----------------------------------------------
      // FOOD NAME
      // -----------------------------------------------

      if (!trimmedName) {
        return;
      }


      // -----------------------------------------------
      // PRICE
      // -----------------------------------------------

      if (
        !price ||
        Number(price) <= 0
      ) {
        return;
      }


      try {

        await onSave({

          foodName:
            trimmedName,

          description:
            trimmedDescription,

          price:
            Number(price),

        });


        // ---------------------------------------------
        // RESET
        // ---------------------------------------------

        setFoodName("");

        setDescription("");

        setPrice(10);


      } catch (error) {

        console.error(
          "Save Menu Error:",
          error
        );

      }

    };


  // =========================================================
  // RENDER
  // =========================================================

  return (

    <div
      className="add-menu-overlay"
      onMouseDown={(event) => {

        if (
          event.target ===
          event.currentTarget
        ) {

          if (!saving) {
            onClose();
          }

        }

      }}
    >

      <div className="add-menu-modal">


        {/* =================================================
            HEADER
        ================================================= */}

        <div className="add-menu-header">

          <div className="add-menu-title">

            <div className="add-menu-icon">

              <MdRestaurant />

            </div>


            <div>

              <span>
                Provider Menu
              </span>

              <h2>
                Add Menu Item
              </h2>

            </div>

          </div>


          <button
            type="button"
            className="add-menu-close"
            onClick={onClose}
            disabled={saving}
            aria-label="Close"
          >

            <MdClose />

          </button>

        </div>


        {/* =================================================
            FORM
        ================================================= */}

        <form
          className="add-menu-form"
          onSubmit={handleSave}
        >


          {/* =================================================
              FOOD NAME
          ================================================= */}

          <div className="add-menu-field">

            <label htmlFor="menu-food-name">
              Food Name
            </label>

            <input
              id="menu-food-name"
              type="text"
              value={foodName}
              onChange={(event) =>
                setFoodName(
                  event.target.value
                )
              }
              placeholder="e.g. Chicken Biryani"
              maxLength={100}
              autoFocus
              disabled={saving}
            />

          </div>


          {/* =================================================
              DESCRIPTION
          ================================================= */}

          <div className="add-menu-field">

            <label htmlFor="menu-food-description">
              Description
              <span>
                Optional
              </span>
            </label>

            <textarea
              id="menu-food-description"
              value={description}
              onChange={(event) =>
                setDescription(
                  event.target.value
                )
              }
              placeholder="e.g. Fragrant basmati rice with chicken and aromatic spices"
              maxLength={300}
              rows={3}
              disabled={saving}
            />

            <div className="add-menu-character-count">

              {description.length}/300

            </div>

          </div>


          {/* =================================================
              PRICE
          ================================================= */}

          <div className="add-menu-field">

            <label>
              Price
            </label>

            <div className="add-menu-price-control">

              <button
                type="button"
                onClick={decreasePrice}
                disabled={
                  saving ||
                  price <= 1
                }
                aria-label="Decrease price"
              >

                <MdRemove />

              </button>


              <div className="add-menu-price">

                <span>
                  ₹
                </span>

                <strong>
                  {price}
                </strong>

              </div>


              <button
                type="button"
                onClick={increasePrice}
                disabled={saving}
                aria-label="Increase price"
              >

                <MdAdd />

              </button>

            </div>

          </div>


          {/* =================================================
              SAVE
          ================================================= */}

          <button
            type="submit"
            className="add-menu-save"
            disabled={
              saving ||
              !foodName.trim() ||
              price <= 0
            }
          >

            {saving
              ? "Saving..."
              : "Save Menu"}

          </button>

        </form>

      </div>

    </div>

  );

}

export default AddMenuModal;